(function(){
  function initAllFeaturedBrands(){
    if(typeof Swiper==="undefined"){
      setTimeout(initAllFeaturedBrands,150);
      return;
    }
    document.querySelectorAll(".featured-brands-slider.swiper").forEach(function(el){
      if(el.swiper)return;
      var id=el.id.replace("featured-brands-slider-","");
      new Swiper(el,{
        slidesPerView:parseInt(el.dataset.mobile)||2,
        spaceBetween:15,
        navigation:{
          nextEl:".swiper-button-next-"+id,
          prevEl:".swiper-button-prev-"+id
        },
        breakpoints:{
          768:{slidesPerView:parseInt(el.dataset.tablet)||5,spaceBetween:15},
          1100:{slidesPerView:parseInt(el.dataset.desktop)||8,spaceBetween:20}
        }
      });
    });
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",initAllFeaturedBrands);
  }else{
    initAllFeaturedBrands();
  }
})();